import styled from 'styled-components';

export const BackDrop = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(44, 44, 44, 0.45);
  z-index: 1000;
`;

export const Modal = styled.div<{ $isOpen: boolean }>``;

export const ModalBody = styled.div`
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Poppins, sans-serif;
  flex-direction: column;
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 1.125rem;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  margin-bottom: -1.2rem;
`;

export const ModalSubtitle = styled.div`
  display: flex;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-align: center;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 0.108rem rgba(0, 0, 0, 0.25);
  border-radius: 0.379rem;
  margin-top: 1.75rem;
  padding: 1rem 0.625rem;
  gap: 1.125rem;
`;

export const ModalTitle = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 0.5rem;
`;

export const ModalContent = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.5rem;
`;

export const AddressFormGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-top: 1.2rem;
`;

export const CityStateZipRow = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  > * {
    flex: 1;
  }
`;
